<template>
  <x-page
    title="商家主页"
    :loading="loading"
    transparent-header
    enable-header-parallax
  >
    <template #header="{ headerParallaxRate }">
      <div
        :class="_.header"
        :style="{
          backgroundColor: `rgba(255,255,255,${
            headerParallaxRate == 0 ? 0 : 1
          })`,
        }"
      >
        <img src="./images/返回.png" alt="" @click="handleServiceClick" />
        <div :class="_.headertxt">商家主页</div>
      </div>
    </template>
    <template v-if="!loading">
      <div :class="_.topcontenel">
        <div :class="_.headerbackground"></div>
        <div :class="_.top">
          <div :class="_['merchants-info']">
            <div :class="_['info-txt']">
              <img :class="_.headImg" :src="chooseStore.logo" alt="" />
              <span :class="[_['merchants-name'], _._ellipsis2]">
                {{ chooseStore.merchantName }}</span
              >
            </div>
            <div :class="_['cheng-shop']" @click="openChangeCheet">
              <span>切换</span>
              <van-icon name="arrow-down" />
            </div>
          </div>
          <div :class="_['merchants-notice']">
            <img :class="_.noticeimg" :src="icon.noticeIcom" alt="" />
            <span :class="[_['notice-txt'], _._ellipsis]">
              {{
                orderStateNum.notice ? orderStateNum.notice : '暂无商家公告!!'
              }}</span
            >
          </div>
          <div :class="_['order-menu']" class="myordermenu">
            <van-cell
              v-track="{
                name: '我的订单-全部',
                id: 'cl9qedyku0000kcughoej0h49',
              }"
              class="vancellstyle"
              :class="_['van-cell-nopad']"
              title="我的订单"
              is-link
              value="全部"
              @click="toMyAllOrder"
            />
            <div :class="_['menu-box']">
              <div
                v-track="{
                  name: '待接单',
                  id: 'cl9qeepu90002kcugcen0hdjj',
                }"
                :class="_['menu']"
                @click="toMyOrder(0)"
              >
                <!-- <img :class="_['menu-icon']" :src="item.icon" alt="" /> -->
                <span :class="_['ordernum']">
                  {{ orderStateNum.waitTakeCount }}
                </span>
                <span :class="_['menu-txt']">待接单</span>
              </div>
              <div
                v-track="{
                  name: '待配送',
                  id: 'cl9qeg0bp0004kcug0lwxaolk',
                }"
                :class="_['menu']"
                @click="toMyOrder(1)"
              >
                <!-- <img :class="_['menu-icon']" :src="item.icon" alt="" /> -->
                <span :class="_['ordernum']">{{
                  orderStateNum.waitDeliverCount
                }}</span>
                <span :class="_['menu-txt']">待配送</span>
              </div>
              <div
                v-track="{
                  name: '配送中',
                  id: 'cl9qegiot0006kcug7e2teen8',
                }"
                :class="_['menu']"
                @click="toMyOrder(2)"
              >
                <!-- <img :class="_['menu-icon']" :src="item.icon" alt="" /> -->
                <span :class="_['ordernum']">{{
                  orderStateNum.deliverCount
                }}</span>
                <span :class="_['menu-txt']">配送中</span>
              </div>
              <div
                v-track="{
                  name: '已完成',
                  id: 'cl9qehz8l0008kcuggmon0njv',
                }"
                :class="_['menu']"
                @click="toMyOrder(3)"
              >
                <!-- <img :class="_['menu-icon']" :src="item.icon" alt="" /> -->
                <span :class="_['ordernum']">{{
                  orderStateNum.doneCount
                }}</span>
                <span :class="_['menu-txt']">已完成</span>
              </div>
              <div
                v-track="{
                  name: '售后/退款',
                  id: 'cl9qeiumt000akcug1gjh015u',
                }"
                :class="_['menu']"
                @click="toMyOrder(4)"
              >
                <!-- <img :class="_['menu-icon']" :src="item.icon" alt="" /> -->
                <span :class="_['ordernum']">{{
                  orderStateNum.saleRefundCount
                }}</span>
                <span :class="_['menu-txt']">售后/退款</span>
              </div>
            </div>
          </div>
          <div :class="_['store-menu']">
            <div
              v-track="{
                name: '店铺设置',
                id: 'cl9qejkr1000ckcug9i1vdo5g',
              }"
              :class="_['menu']"
              @click="toStoreSet"
            >
              <img :class="_['menu-icon']" :src="icon.orderSetIcon" alt="" />
              <span :class="_['menu-txt']">店铺设置</span>
              <!-- <div  :class="_['badge']">99</div> -->
            </div>
            <div
              v-track="{
                name: '订单管理',
                id: 'cl9qejuas000ekcug85lz8lky',
              }"
              :class="_['menu']"
              @click="toMyAllOrder"
            >
              <img :class="_['menu-icon']" :src="icon.ordermanageIcon" alt="" />
              <span :class="_['menu-txt']">订单管理</span>
              <!-- <div  :class="_['badge']">99</div> -->
            </div>
            <div
              v-track="{
                name: '配送人员',
                id: 'cl9qekpdh000gkcug7o78hsky',
              }"
              :class="_['menu']"
            >
              <img
                :class="_['menu-icon']"
                :src="icon.orderPersonIcon"
                alt=""
                @click="toDelivery"
              />
              <span :class="_['menu-txt']">配送人员</span>
            </div>
            <div
              v-track="{
                name: '售后管理',
                id: 'cl9qekz5n000ikcug93iq1kj6',
              }"
              :class="_['menu']"
              @click="toSales"
            >
              <img :class="_['menu-icon']" :src="icon.aftersalesIcon" alt="" />
              <span :class="_['menu-txt']">售后管理</span>
              <div
                v-if="
                  orderStateNum.refundingCount ||
                  orderStateNum.refundingCount != 0
                "
                :class="_['badge']"
              >
                <div :class="_.numtxt">
                  {{
                    orderStateNum.refundingCount > 100
                      ? '99+'
                      : orderStateNum.refundingCount
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="_['order-list-box']">
        <div :class="_['list-box-refresh']">
          <div :class="_['refresh-ordertype']">待接单订单</div>
          <div
            v-track="{
              name: '待接单订单-刷新',
              id: 'cl9qelniz000kkcug5j4u7w8z',
            }"
            :class="_['refresh-icontxt']"
            @click="refreshOrder"
          >
            <img :class="_.refreshIcon" :src="icon.refreshIcon" alt="" />
            <span :class="_['refresh-txt']">刷新</span>
          </div>
        </div>
        <!-- 订单列表 -->
        <x-waterfall
          :key="chooseStore.merchantId + refreshIndex"
          :load="handleLoad"
        >
          <template #default="{ data }">
            <template v-for="order in data">
              <orderItem
                v-if="order.saleAfterStatus != 1"
                :key="order.orderNo"
                :order-info="order"
                @operation="operation"
              />
            </template>
          </template>
        </x-waterfall>
      </div>

      <shopSheet
        :list="storeList"
        :choosed="chooseStore"
        :show="show"
        @closeEmit="changeStore"
      />
    </template>
  </x-page>
</template>

<script>
  import icon from './icon'
  import orderItem from './orderItem.vue'
  import shopSheet from './components/changeShopSheet.vue'
  import Vue from 'vue'
  import {
    apiOrderMerchantIndex,
    apiOrderMerchantOrderList,
    apiOrderMerchantStoreList,
  } from '@/api'
  import { navigateBack } from '@/router'
  import { newRouteOnValueChange } from '@/utils'
  import { Track } from '@/utils/Track'

  export default Vue.extend({
    components: { orderItem, shopSheet },
    mixins: [
      Track.provideMark(() => ({
        page: '商家主页',
      })),
    ],
    data() {
      return {
        icon: icon,
        ordermenu: ['待接单', '待配送', '配送中', '已完成', '售后/退款'],
        show: false,
        hasStore: false, //是否查询到商家信息或其它异常情况
        storeList: [],
        chooseStore: {
          // defaultChoose: true, //是否默认选中
          // logo: icon.noticeIcom, //logo图片
          // merchantId: 'ahd11233', //店铺Id
          // merchantName: '贵州蔬菜研究基地有限责任公司', //店铺名称
          // notice: '新店开业，欢迎您的光临，本店服务至上的如果您新…', //公告
        },
        orderList: [],
        orderStateNum: {
          deliverCount: 0, //配送中数量
          doneCount: 0, //已完成数量
          refundingCount: 0, //售后进行中数量
          saleRefundCount: 0, //售后/退款数量数量
          waitDeliverCount: 0, //待配送数量
          waitTakeCount: 0, //待接单数量
        },
        refreshIndex: 0,
      }
    },
    computed: {
      loading() {
        return false
      },
    },
    mounted() {
      if (localStorage.getItem('choose-store')) {
        this.chooseStore = JSON.parse(localStorage.getItem('choose-store'))
      }
      this.$nextTick(() => {
        //挂载完毕获取商户信息
        this.getStoreAllInfoList()
      })

      newRouteOnValueChange({
        ctx: this,
        valueName: 'show',
        callback: v => {
          if (!v) {
            this.show = false
          }
        },
      })
    },
    methods: {
      //订单操作回调,刷新列表，刷新我的订单数量
      operation() {
        this.refreshIndex++
      },
      //订单列表
      handleLoad({ pageNumber }) {
        if (this.hasStore) {
          const promise = apiOrderMerchantOrderList(
            {
              pageIndex: pageNumber,
              pageSize: 10,
              status: 7,
            },
            { hasStoreCode: true },
          ).then(
            res => {
              res.list = res.list.filter(item => {
                return item.saleAfterStatus !== 1
              })
              return new Promise(resolve => {
                if (res) resolve(res)
              })
            },
            err => {
              console.log('err---->', err)
            },
          )
          this.getOrderStateNum()
          return promise
        }
      },
      async getStoreAllInfoList() {
        const result = await apiOrderMerchantStoreList()
        this.hasStore = true
        this.storeList = result
        this.loading = true
        if (JSON.stringify(this.chooseStore) === '{}') {
          const defaultList = this.storeList.filter(item => {
            return item.defaultChoose
          })
          this.chooseStore = defaultList[0]
        }
        localStorage.setItem('choose-store', JSON.stringify(this.chooseStore))
        //将店铺id存入本地
        localStorage.setItem('X-Store-Code', this.chooseStore.merchantId)
        this.refreshIndex++
        // this.getOrderList()
      },
      //切换商家店铺
      changeStore(value) {
        if (!this.hasStore) return
        this.show = false
        if (value) {
          this.chooseStore = value
          //将店铺id存入本地
          localStorage.setItem('X-Store-Code', value.merchantId)
          localStorage.setItem('choose-store', JSON.stringify(this.chooseStore))
          // this.getOrderList()
        }
      },
      //我的订单（全部）
      toMyAllOrder() {
        this.$destroy()
        if (!this.hasStore) return
        this.$router.push({
          path: '/manage/orderdelivery/index',
          query: {
            type: 0,
          },
        })
      },
      //我的订单
      toMyOrder(index) {
        this.$destroy()
        if (!this.hasStore) return
        this.$router.push({
          path: '/manage/orderdelivery/index',
          query: {
            type: index + 1,
          },
        })
      },
      //店铺基础设置
      toStoreSet() {
        this.$destroy()
        if (!this.hasStore) return
        this.$router.push({
          path: '/manage/basicset/index',
        })
      },
      //配送人员管理
      toDelivery() {
        this.$destroy()
        if (!this.hasStore) return
        this.$router.push({
          path: '/manage/deliveryperson/index',
        })
      },
      //根据店铺信息获取待接单列表信息
      // async getOrderList() {
      //   const result = await apiOrderMerchantOrderList(
      //     {
      //       pageIndex: 1,
      //       pageSize: 10,
      //       status: 7,
      //     },
      //     { hasStoreCode: true },
      //   )
      //   this.orderList = result.list
      // },
      //刷新订单信息
      refreshOrder() {
        // this.getOrderList()
        this.refreshIndex++
      },
      //获取订单个状态的数量
      async getOrderStateNum() {
        const result = await apiOrderMerchantIndex({}, { hasStoreCode: true })
        this.orderStateNum = result
      },

      //打开切换弹层
      openChangeCheet() {
        this.show = true
      },
      //去售后
      toSales() {
        this.$destroy()
        if (!this.hasStore) return
        this.$router.push({
          path: '/manage/afterSales',
        })
      },
      handleServiceClick() {
        navigateBack()
      },
    },
  })
</script>

<style lang="scss" module>
  .header {
    width: 100%;
    height: 100%;
    padding: 0 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .headertxt {
      width: 100%;
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      text-align: center;
    }
  }

  .topcontenel {
    padding-top: var(--real-page-header-height);
    .headerbackground {
      width: 100%;
      height: 168px;
      position: absolute;
      top: 0;
      z-index: -1111111;
      background-image: url('./images/背景.png');
      background-size: 100% 168px;
      // opacity: 0.6;
    }
    .top {
      padding: 0 12px;
      .merchants-info {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .info-txt {
          width: calc(100% - 49px);
          display: flex;
          align-items: center;
        }
        .headImg {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
        .merchants-name {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          margin-left: 10px;
        }
        .cheng-shop {
          width: 42px;
          font-size: 12px;
          font-weight: 400;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #333333;
        }
      }
      .merchants-notice {
        width: calc(100% - 16px);
        height: 17px;
        margin-top: 10px;
        background: #ffffff;
        border-radius: 8px;
        padding: 8px;
        display: flex;
        align-items: center;
        .noticeimg {
          width: 28px;
          height: 16px;
          padding-right: 8px;
          border-right: 1px solid #e1e1e1;
        }
        .notice-txt {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          padding-left: 8px;
        }
      }
      .order-menu {
        width: calc(100% - 24px);
        height: 77px;
        margin-top: 11px;
        background: #ffffff;
        border-radius: 8px;
        padding: 12px;
        .van-cell-nopad {
          padding: 0;
        }
        .menu-box {
          padding: 0 7px;
          display: flex;
          justify-content: space-between;
          .menu {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 12px;
            // .menu-icon {
            //   width: 24px;
            //   height: 24px;
            // }
            .ordernum {
              font-size: 18px;
              font-weight: 500;
              color: #333333;
            }
            .menu-txt {
              font-size: 12px;
              font-weight: 400;
              color: #333333;
            }
          }
        }
      }
      .store-menu {
        width: calc(100% - 36px);
        height: 51px;
        margin-top: 10px;
        background: #ffffff;
        border-radius: 8px;
        padding: 12px 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .menu {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          .menu-icon {
            width: 28px;
            height: 28px;
          }
          .menu-txt {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            margin-top: 6px;
          }
          .badge {
            position: absolute;
            left: 26px;
            top: -8px;
            // width: 20px;
            height: 12px;
            line-height: 12px;
            text-align: center;
            font-size: 12px;
            font-weight: 500;
            color: #ffffff;
            background-color: #ff2438;
            border-radius: 32px 32px 32px 0px;
            border: 1px solid #ffffff;
            .numtxt {
              width: 21px;
              transform: scale(0.8) !important;
            }
          }
        }
      }
    }
  }

  .order-list-box {
    width: calc(100% - 24px);
    min-height: 369px;
    padding: 12px 12px 52px 12px;
    margin-top: 10px;
    background: #fff;
    .list-box-refresh {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      .refresh-ordertype {
        font-size: 17px;
        font-weight: 500;
        color: #333333;
      }
      .refresh-icontxt {
        display: flex;
        align-items: center;
        .refreshIcon {
          width: 15px;
          height: 15px;
        }
      }

      .refresh-txt {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        margin-left: 5px;
      }
    }
    .order-contenal {
      margin-top: 11px;
    }
  }
</style>
<style lang="scss">
  .index_order-menu__FFE7,
  .myordermenu {
    .van-cell::after {
      border-bottom: none;
    }
  }
  .vancellstyle {
    .van-cell__title {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
    }
    .van-cell__value {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
    .van-icon {
      font-size: 12px;
    }
  }
</style>
